import { h, Component } from "preact";
import { connectWithTranslations } from "../../../../common/helpers/translationsHelpers";
import {
    COUNTRY_FILTER_OPTIONS,
    getMajorCountries,
    getMinorCountries,
    GTM_ID, GA4EVENT,
} from "../../../constants";
import CheckboxPicker from "../../../../common/components/CheckboxPicker";
import IconCaretDown from "../../../../common/components/icons/IconCaretDown";
import actions from "../../../actions";
import { getKeysOfNotNullValues } from "../../../../common/helpers/objects";

const CountryCheckboxValue = ({ code, text }) => (
    <div class="fxs_c_filter_picker" style="display: inline-block">
        <span
            class={`fxs_flag fxs_${code.toLowerCase()}`}
            title={text}
            style="display: inherit"
        ></span>
        <span class="fxs_c_country-name">{text}</span>
    </div>
);

class AdvancedCountryFilterMobile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPickerOpen: false,
            filteredCountries: null,
            selected: [],
        };

        this.togglePicker = this.togglePicker.bind(this);
        this.applyNewSelectedCountries =
            this.applyNewSelectedCountries.bind(this);
    }

    componentWillMount() {
        const countries = getKeysOfNotNullValues(COUNTRY_FILTER_OPTIONS);
        const translatedCountries = countries.map((x) => {
            return {
                key: x,
                name: this.props.translate(x),
            };
        });

        const majorCountries = getMajorCountries(countries);
        const minorCountries = getMinorCountries(countries);
        const selected = this.props.selectedCountries;

        this.setState({
            countries,
            translatedCountries,
            majorCountries,
            minorCountries,
            selected,
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.selectedCountries !== nextProps.selectedCountries) {
            const selected = this.state.countries.filter((key) =>
                nextProps.selectedCountries.includes(
                    COUNTRY_FILTER_OPTIONS[key]
                )
            );

            this.setState({
                selected: selected.map((x) => COUNTRY_FILTER_OPTIONS[x]),
            });
        }
    }

    togglePicker() {
        if (this.state.isPickerOpen)
            this.setState({
                isPickerOpen: false,
                filteredCountries: null,
                selected: this.props.selectedCountries,
            });
        else this.setState({ isPickerOpen: true });
    }

    onChangeCountriesSelected(newSelected) {
        if (this.state.filteredCountries !== null) {
            var filteredCountriesCodes = this.state.filteredCountries.map(
                (x) => COUNTRY_FILTER_OPTIONS[x]
            );
            this.state.selected.forEach((element) => {
                if (!filteredCountriesCodes.includes(element)) {
                    newSelected.push(element);
                }
            });
        }
        this.setState({
            selected: newSelected,
        });
    }

    applyNewSelectedCountries(selected) {
        this.props.onChange(selected);
        this.togglePicker();
    }

    searchCountries = (text) => {
        let filtered = this.state.translatedCountries.filter((x) => {
            var result = x.name.toLowerCase().indexOf(text.toLowerCase()) > -1;
            return result;
        });

        this.setState({ filteredCountries: filtered.map((x) => x.key) });
    };

    filterCountry = (e) => {
        if (e.isComposing || e.keyCode === 229) {
            return;
        }
        let value = e.target.value;
        this.searchCountries(value);
    };

    render(
        { onChange, translate, config, selectedCountries },
        {
            countries,
            majorCountries,
            minorCountries,
            filteredCountries,
            selected,
        }
    ) {
        let actualMajorCountries = majorCountries;
        let actualMinorCountries = minorCountries;

        if (filteredCountries && filteredCountries.length > 0) {
            actualMajorCountries = actualMajorCountries.filter((x) =>
                filteredCountries.includes(x)
            );
            actualMinorCountries = actualMinorCountries.filter((x) =>
                filteredCountries.includes(x)
            );
        }

        const majorSelected = getSelected(majorCountries, selected);
        const minorSelected = getSelected(minorCountries, selected);

        return (
            <div class="fxs_c_advanced-countries-filter">
                <button
                    type="button"
                    onClick={this.togglePicker}
                    class="fxs_c_filter_picker_trigger_button"
                >
                    <span>
                        {translate("CountryFilterTitle")} ({selected.length})
                    </span>
                    <IconCaretDown />
                </button>
                {this.state.isPickerOpen && (
                    <div
                        class="fxs_c_advanced-countries-backdrop"
                        onClick={this.togglePicker}
                    ></div>
                )}
                {this.state.isPickerOpen && (
                    <div class="fxs_c_filters_picker">
                        <div class="fxs_c_countries_search_box">
                            <input
                                onKeyUp={this.filterCountry}
                                type="search"
                                class="fxs_search_input"
                                placeholder={translate(
                                    "AdvancedFilter_Search_Country"
                                )}
                                name="search"
                                autocomplete="off"
                            />
                            <label
                                class="fxs_btn_filter"
                                title={translate(
                                    "AdvancedFilter_Search_Country"
                                )}
                            ></label>
                        </div>
                        <div class="fxs_clearfix">
                            <button
                                type="button"
                                class="fxs_btn fxs_btn_anchor fxs_btn_large fxs_fLeft"
                                data-gtmid={
                                    config.tracking &&
                                    GTM_ID.ADVANCED_FILTERS_COUNTRY_CHECKBOX(
                                        "all"
                                    )
                                }
                                data-ga4event-clk-name={config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                                data-ga4event-element={
                                    config.tracking &&
                                    GA4EVENT.ELEMENTS.ADVANCED_FILTERS_COUNTRY_CHECKBOX
                                }
                                data-ga4event-country={config.tracking && "all"}
                                onClick={() =>
                                    this.onChangeCountriesSelected(
                                        getValues(countries, [])
                                    )
                                }
                            >
                                <span>
                                    <span>
                                        {translate("AdvancedFilterAllLabel")}
                                    </span>
                                </span>
                            </button>
                            <button
                                type="button"
                                class="fxs_btn fxs_btn_anchor fxs_btn_large fxs_fRight"
                                data-gtmid={
                                    config.tracking &&
                                    GTM_ID.ADVANCED_FILTERS_COUNTRY_CHECKBOX(
                                        "clear"
                                    )
                                }
                                data-ga4event-clk-name={config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                                data-ga4event-element={
                                    config.tracking &&
                                    GA4EVENT.ELEMENTS.ADVANCED_FILTERS_COUNTRY_CHECKBOX
                                }
                                data-ga4event-country={config.tracking && "clear"}
                                onClick={() =>
                                    this.onChangeCountriesSelected([])
                                }
                            >
                                <span>
                                    <span>
                                        {translate("AdvancedFilterNoneLabel")}
                                    </span>
                                </span>
                            </button>
                        </div>
                        <div class="fxs_c_filter_picker_list">
                            <CheckboxPicker
                                onChange={(values) =>
                                    this.onChangeCountriesSelected(
                                        getValues(values, minorSelected)
                                    )
                                }
                                values={actualMajorCountries}
                                checkedValues={majorSelected}
                                renderTitle={() => { }}
                                renderValue={(value) => (
                                    <CountryCheckboxValue
                                        code={COUNTRY_FILTER_OPTIONS[value]}
                                        text={translate(value)}
                                    />
                                )}
                                getOptionGtmId={(key) =>
                                    config.tracking &&
                                    GTM_ID.ADVANCED_FILTERS_COUNTRY_CHECKBOX(
                                        key
                                            .replace("Country_", "")
                                            .toLowerCase()
                                    )
                                }
                                getOptionGA4Id={(key)=>
                                    config.tracking &&
                                    GA4EVENT.ELEMENTS.ADVANCED_FILTERS_COUNTRY_CHECKBOX
                                }
                                getOptionGa4ThirdTrackingId={(key) => ({ "data-ga4event-country": `${key.replace("Country_", "").toLowerCase()}` })}
                                getGa4Name={
                                    config.tracking &&
                                    GA4EVENT.NAMES.FEATURES_CALENDAR
                                }
                                labelClass="fxs_c_filter_picker_label"
                            />

                            <div class="fxs_clearfix"></div>
                            <hr />
                            <div class="fxs_clearfix"></div>

                            <CheckboxPicker
                                onChange={(values) =>
                                    this.onChangeCountriesSelected(
                                        getValues(majorSelected, values)
                                    )
                                }
                                values={actualMinorCountries}
                                checkedValues={minorSelected}
                                renderTitle={() => { }}
                                renderValue={(value) => (
                                    <CountryCheckboxValue
                                        code={COUNTRY_FILTER_OPTIONS[value]}
                                        text={translate(value)}
                                    />
                                )}
                                getOptionGtmId={(key) =>
                                    config.tracking &&
                                    GTM_ID.ADVANCED_FILTERS_COUNTRY_CHECKBOX(
                                        key
                                            .replace("Country_", "")
                                            .toLowerCase()
                                    )
                                }
                                getOptionGA4Id={(key)=>
                                    config.tracking &&
                                    GA4EVENT.ELEMENTS.ADVANCED_FILTERS_COUNTRY_CHECKBOX
                                }
                                getOptionGa4ThirdTrackingId={(key) => ({ "data-ga4event-country": `${key.replace("Country_", "").toLowerCase()}` })}
                                getGa4Name={config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                                labelClass="fxs_c_filter_picker_label"
                            />
                        </div>
                        <div class="fxs_c_filter_picker_footer">
                            <button
                                type="button"
                                onClick={() => this.togglePicker()}
                                class="fxs_btn fxs_btn_phantom fxs_fLeft"
                            >
                                {" "}
                                {this.props.translate("Cancel")}
                                {"Cancel"}
                            </button>
                            <button
                                type="button"
                                onClick={() =>
                                    this.applyNewSelectedCountries(selected)
                                }
                                class="fxs_btn fxs_btn_cta fxs_fRight"
                            >
                                {" "}
                                {this.props.translate("Done")}
                                {"Done"}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const getSelected = (countries, selected) =>
    selected.length === 0
        ? []
        : countries.filter((key) =>
            selected.includes(COUNTRY_FILTER_OPTIONS[key])
        );

const getValues = (selected, others) => {
    let result = [];
    result = result.concat(selected.map((x) => COUNTRY_FILTER_OPTIONS[x]));
    result = result.concat(others.map((x) => COUNTRY_FILTER_OPTIONS[x]));
    return result;
};

export default connectWithTranslations(
    "config",
    actions
)(AdvancedCountryFilterMobile);
